import React, { useEffect } from 'react';
import { SITE_URL } from '../../constants';
import './CatalogRequest.css';

class CatalogRequestConfirmation extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <React.Fragment>
                <main className="techtop-middle-div" id="catalog-request-section">
                    <section className="py-2">	
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="default-title">
                                        <h2 className="txt-color2">Catalog Request</h2>
                                    </div>										
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-md-12">
                                    <p>Your catalog request has been submitted.</p>
                                    <p>You will receive an email confirmation after we have processed your request.</p>
                                    <p>Your catalog(s) will arrive within 1-4 business days</p>
                                    <p><a href={`/downloads/`} className="color1 text-decoration-underline"><strong>View Online Catalog</strong></a>&nbsp; &nbsp;&nbsp; &nbsp;<a href={`/`} className="color1 text-decoration-underline"><strong>Home</strong></a></p>
                                </div>
                            </div>
                        </div>
                    </section>		 
                    
                </main>
            </React.Fragment>
        )
    }
}

export default CatalogRequestConfirmation;